import { gql } from "apollo-boost";

const articles = gql`
  query articles($filter: ArticleFilter!) {
    articles(filter: $filter) {
      total
      items {
        id
        title
        type
        retired
        updatedAt
        unread
      }
    }
  }
`;

const article = gql`
  query article($id: String!) {
    article(id: $id) {
      id
      title
      description
      content
      images {
        url
        imageWidth
        imageHeight
        imageSize
      }
      videos {
        url
        imageWidth
        imageHeight
        imageSize
      }
      type
      retired
    }
  }
`;

const articlePublishRegions = gql`
  query articlePublishRegions($articleId: String) {
    articlePublishRegions(articleId: $articleId) {
      id
      name
      nodes {
        id
        name
        nodes {
          id
          name
        }
      }
    }
  }
`;

const articlePublishes = gql`
  query articlePublishes($filter: ArticlePublishFilter!) {
    articlePublishes(filter: $filter) {
      total
      items {
        id
        articleId
        state
        platform
        type
        commentType
        communities {
          id
          name
        }
        publishDate
        publishBy
        publishToNewUser
        publishDay
        publishTime
      }
    }
  }
`;

const articleComments = gql`
  query articleComments($filter: ArticleCommentFilter!) {
    articleComments(filter: $filter) {
      total
      items {
        CommentId
        ResourceId
        Comment
        CreatedAt
        createdBy
      }
    }
  }
`;

const saveArticle = gql`
  mutation saveArticle($input: ArticleInput!) {
    saveArticle(input: $input)
  }
`;

const saveArticlePublish = gql`
  mutation saveArticlePublish($input: ArticlePublishInput!) {
    saveArticlePublish(input: $input)
  }
`;

const withdrawnArticlePublish = gql`
  mutation withdrawnArticlePublish($id: String!) {
    withdrawnArticlePublish(id: $id)
  }
`;

export const articleGql = {
  articles,
  article,
  saveArticle,
  articlePublishRegions,
  saveArticlePublish,
  articlePublishes,
  withdrawnArticlePublish,
  articleComments,
};
